// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__kyb-p","list":"styles_list__73e3w","item":"styles_item__hgNaC","item_title":"styles_item_title__+yLR-"};